<template>
    <div class="modal-container">
        <div class="modal-backdrop" v-bind:style="modalBackdropStyle"></div>
        <div class="modal-container__panel" v-bind:style="modalContainerPanelStyle" @click="close">
            <div class="modal" role="modal" v-bind:style="modalStyle" v-on:click.stop>
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable vue/return-in-computed-property */

export default {
    name: 'biller-modal',
    props: {
        isVisible: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        isVisible() {
            if (this.isVisible) {
                document.body.style.overflowY = 'hidden'
            } else {
                document.body.style.overflowY = 'scroll'
            }
        },
    },
    methods: {
        close() {
            this.$emit('close')
        },
    },
    computed: {
        modalContainerPanelStyle() {
            if (this.isVisible) {
                return {
                    visibility: 'visible',
                }
            }
        },
        modalStyle() {
            if (this.isVisible) {
                return {
                    transform: 'scale(1)',
                    opacity: 1,
                    WebkitTransform: 'scale(1)',
                }
            }
        },
        modalBackdropStyle() {
            if (this.isVisible) {
                return {
                    opacity: 0.9,
                    visibility: 'visible',
                }
            }
        },
    },
}
</script>
<style lang="scss">
.modal-backdrop {
    width: 100%;
    height: 100vh;
    position: absolute;
    top: 0;
    right: 0;
    overflow: hidden;
    z-index: 10;
    visibility: hidden;
    background: rgba(60, 25, 82, 0.1);
    backdrop-filter: blur(3px);
    opacity: 0;
    will-change: opacity;
    transition: opacity 0.233s cubic-bezier(0, 0, 0.21, 1);
}
.modal-container__panel {
    position: relative;
    overflow-y: auto;
    height: 100vh;
    position: fixed;
    padding: 30px 0;
    left: 0;
    top: 0;
    z-index: 9999;
    visibility: hidden;
    right: 0;
    background: none;
    display: flex;
    justify-content: center;
    align-items: center;
    .modal {
        // max-width: 1150px;
        margin: 0 auto;
        // box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.09);
        transition: transform 0.3s ease-out;
        transition: -webkit-transform 0.233s cubic-bezier(0, 0, 0.21, 1);
        transition: transform 0.233s cubic-bezier(0, 0, 0.21, 1);
        transition: transform 0.233s cubic-bezier(0, 0, 0.21, 1), -webkit-transform 0.233s cubic-bezier(0, 0, 0.21, 1);
        transition: all 0.3s cubic-bezier(0, 0, 0.21, 1);
        opacity: 0;
        outline: none;
        will-change: transform;
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
        background: #ffffff;
        border-radius: 10px;
        // @media screen and (max-width: 1000px) {
        //     margin: 70px 20px;
        // }
    }
}
.container {
    width: 100%;
}
</style>
